import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { type ReactNode, createElement, useMemo } from 'react';
import { I18nHtmlProps } from './types';
import TextLink from '@/components/TextLink';
import type { NextIntlKeys, RichTranslator } from '@/i18n/types';
const SUPPORTED_GENERIC_TAGS = ['strong', 'i', 'p', 'span', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ol', 'ul', 'li'] as const;
type SUPPORTED_GENERIC_TAGS = (typeof SUPPORTED_GENERIC_TAGS)[number];
type RenderFn = (chunks: ReactNode) => ReactNode;
const defaultRenderers = SUPPORTED_GENERIC_TAGS.reduce((acc, tag) => {
  acc[tag] = (chunks: ReactNode) => createElement(tag, {}, chunks);
  return acc;
}, {} as Record<SUPPORTED_GENERIC_TAGS, RenderFn>);
function I18nHtml(t0) {
  const $ = _c(20);
  let i18nKey;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      i18nKey,
      as: t1,
      options: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = i18nKey;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
  } else {
    i18nKey = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const as = t1 === undefined ? "span" : t1;
  let t3;
  if ($[5] !== t2) {
    t3 = t2 === undefined ? {} : t2;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const options = t3;
  const t = useTranslations("nextjs");
  let t4;
  if ($[7] !== i18nKey || $[8] !== options || $[9] !== t) {
    let t5;
    let t6;
    let t7;
    let t8;
    if ($[11] !== options) {
      t5 = chunks => {
        const attrs = options.target && options.target === "_blank" ? {
          rel: "noopener noreferrer"
        } : {};
        return <TextLink href={options.href as string} target={options.target as string} {...attrs}>{chunks}</TextLink>;
      };
      t6 = chunks_0 => {
        const attrs_0 = options.target1 && options.target1 === "_blank" ? {
          rel: "noopener noreferrer"
        } : {};
        return <TextLink href={options.href1 as string} target={options.target1 as string} {...attrs_0}>{chunks_0}</TextLink>;
      };
      t7 = chunks_1 => {
        const attrs_1 = options.target2 && options.target2 === "_blank" ? {
          rel: "noopener noreferrer"
        } : {};
        return <TextLink href={options.href2 as string} target={options.target2 as string} {...attrs_1}>{chunks_1}</TextLink>;
      };
      t8 = chunks_2 => {
        const attrs_2 = options.target3 && options.target3 === "_blank" ? {
          rel: "noopener noreferrer"
        } : {};
        return <TextLink href={options.href3 as string} target={options.target3 as string} {...attrs_2}>{chunks_2}</TextLink>;
      };
      $[11] = options;
      $[12] = t5;
      $[13] = t6;
      $[14] = t7;
      $[15] = t8;
    } else {
      t5 = $[12];
      t6 = $[13];
      t7 = $[14];
      t8 = $[15];
    }
    t4 = t.rich(i18nKey as Parameters<RichTranslator>[0], {
      ...defaultRenderers,
      a: t5,
      a1: t6,
      a2: t7,
      a3: t8,
      br: _temp,
      ...options
    });
    $[7] = i18nKey;
    $[8] = options;
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const value = t4;
  const Tag = as;
  let t5;
  if ($[16] !== Tag || $[17] !== props || $[18] !== value) {
    t5 = <Tag {...props}>{value}</Tag>;
    $[16] = Tag;
    $[17] = props;
    $[18] = value;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
}
function _temp() {
  return <br />;
}
export default I18nHtml;